<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      style="overflow: visible"
      @md-clicked-outside="closeDialog"
    >
      <div class="custom-header">
        <md-dialog-title>
          <a v-if="showReceipt" class="close-receipt-btn" href="#" @click.prevent="showReceipt = false">Назад</a>
          <template v-else>
            Оплата
          </template>
        </md-dialog-title>
        <md-button
          class="md-button md-just-icon md-simple md-white"
          @click="closeDialog"
        >
          <i class="material-icons ">close</i>
        </md-button>
      </div>

      <md-card class="mobile-card payment-dialog-card text-main-black">
        <md-card-content class="mobile-content">
          <div class="dialog-payment-wrapper">
            <template v-if="showReceipt">
              <embed
                class="pdf-iframe"
                type="application/pdf"
                :src="paymentData.receiptUrl + '#toolbar=1&navpanes=1&scrollbar=0'"
                width="100%"
              >
            </template>
            <template v-else>
              <form id="tForm" style="display: none;" onsubmit="pay(this); return false;" name="TinkoffPayForm">
                <input name="terminalkey" type="hidden" :value="paymentData.bankTerminalKeyWebsite">
                <input name="customerKey" type="hidden" :value="order.customerkey" />
                <input name="amount" type="text" required :value="totalAmount">
                <input name="order" type="text" :value="order.orderId">
                <input name="phone" type="text" :value="getUsername">
                <input name="frame" type="hidden" value="true">
                <input name="language" type="hidden" value="ru">
                <input name="reccurentPayment" type="hidden" value="false" />
                <input name="description" type="text">
                <input name="name" type="text">
                <input name="email" type="text">
                <input id="tFormBtn" type="submit" value="Оплатить" />
              </form>
              <div class="table-title md-theme-block-head-color">Введите сумму</div>
              <table class="custom-dense-table dialog-payment-table">
                <tbody>
                <tr>
                  <td>
                    <a
                      v-if="paymentData.receiptUrl"
                      style="margin-right: 5px;"
                      href="#"
                      @click="showReceipt = true"
                    >
                      <md-icon>visibility</md-icon>
                    </a>
                    {{ paymentData.title }}
                  </td>
                  <td class="text-align-right">
                    <input class="amount-input" v-model="paymentData.amount">
                  </td>
                </tr>
                <tr>
                  <td><span>Комиссия ({{ paymentData.commissionPercent }}%)</span></td>
                  <td class="text-align-right">{{ commissionAmount }}</td>
                </tr>
                </tbody>
              </table>
              <div class="total-amount">
                Итого: {{ totalAmount | currency }}
              </div>
              <div class="text-align-center">
                <md-button @click.prevent="createOrder">
                  Перейти к оплате
                </md-button>
              </div>
            </template>
          </div>
        </md-card-content>
      </md-card>

    </md-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import to from "await-to-js";
import api from "@/api";

export default {
  name: "DialogToPayment",
  data() {
    return {
      show: false,
      showReceipt: false,
      receiptUrl: null,
      order: {
        orderId: null,
        customerkey: null
      },
      paymentData: {
        id: null,
        title: null,
        resource: null,
        amount: 0,
        bankTerminalKeyWebsite: null,
        commissionMinimum: 0,
        commissionPercent: 0,
        commissionPlus: 0,
      }
    };
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    payment: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {
    this.paymentData = { ...this.payment };
    this.paymentData.commissionMinimum = Number(this.paymentData.commissionMinimum)
    this.paymentData.commissionPlus = Number(this.paymentData.commissionPlus)
    this.paymentData.commissionPercent = Number(this.paymentData.commissionPercent).toFixed(1)
  },
  computed: {
    ...mapGetters(['getUsername']),

    commissionAmount() {
      let { amount } = this.paymentData;
      const { commissionMinimum, commissionPercent, commissionPlus } = this.paymentData;
      amount = parseFloat(amount) || 0;

      if (amount === 0) {
        return Number(0).toFixed(2)
      }
      const commissionVal = (commissionPercent / 100) * amount;

      let total = commissionVal + commissionPlus
      total = total < commissionMinimum ? commissionMinimum : total

      return this.round(total)
    },

    totalAmount() {
      const { commissionAmount } = this;
      let { amount } = this.paymentData;
      amount = parseFloat(amount) || 0;
      return this.round(commissionAmount + amount)
    },
  },
  methods: {
    round(val) {
      const x = val * 100;
      const y = Math.trunc(x);
      const z = x - y;
      return z > 0 ? (y + 1) / 100 : y / 100;
    },

    async createOrder() {
      const payload = {
        accrualId: this.paymentData.id,
        amount: this.totalAmount,
        consumerPhone: this.getUsername,
        method: 5
      };

      const [err, resp] = await to(api.payments.createPaymentOrder(payload));
      if (err) {
        this.$notifyDanger('Ошибка');
        return;
      }
      this.order = resp.data;
      const tFormBtn = window.document.getElementById('tFormBtn');
      this.$nextTick(() => {
        tFormBtn.click();
        this.closeDialog();
      })
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss">
.navbar {
  display: none !important;
}
.t-frame {
  height: 100% !important;
}
</style>

<style lang="scss" scoped>
@import "../../../assets/scss/md/variables";
.close-receipt-btn {
  color: #ffffff !important;
  &:hover {
    color: #ffffff !important;
  }
}
.payment-dialog-card {
  margin: 0;
  min-width: 500px;
  @media (max-width: 600px) {
    min-width: unset;
  }
}
.pdf-iframe {
  width: 600px;
  height: 800px;
  max-height: unset;
  border: 0;
  @media (max-width: 600px) {
    height: 100vh;
  }
}
.dialog-payment-wrapper {
  padding: 0 10px;
  @media (max-width: 768px) {
    padding: 10px 0 0 0;
  }
  .total-amount,
  .table-title {
    font-size: 17px;
    font-weight: 400;
    @media (max-width: 768px) {
      text-transform: uppercase;
      padding: 10px 8px;
    }
  }
  .total-amount {
    text-align: right;
    margin: 8px 0 20px 0;
    font-weight: 700;
  }
  .dialog-payment-table {
    background-color: #ffffff;
    .show-pdf-td {
      width: 30px;
      .md-icon {
        font-size: 20px!important;
        width: 20px;
        height: 20px;
      }
    }
    tbody tr {
      cursor: default;
      &:hover {
        background-color: #ffffff;
      }
    }
    .amount-input {
      width: 80px;
      height: 20px;
      border: 1px solid #eee;
      font-family: Roboto,Helvetica,Arial,sans-serif;
      font-size: 14px;
      color: #3c4858;
      &::placeholder {
        color: var(--md-theme-text-light-grey-color);
      }
    }
  }
}
.md-dialog {
  max-width: 768px;
  max-height: 100%;
  background-color: #eeeeee !important;
  .custom-header {
    display: flex;
    background-color: var(--md-theme-main-bar-color);
    color: #ffffff;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    height: 65px;
    width: 100%;
  }
}
</style>
